import { render } from "./DatosBasicosPlay.vue?vue&type=template&id=070bb7c4&scoped=true"
import script from "./DatosBasicosPlay.vue?vue&type=script&lang=js"
export * from "./DatosBasicosPlay.vue?vue&type=script&lang=js"

import "./DatosBasicosPlay.vue?vue&type=style&index=0&id=070bb7c4&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070bb7c4"]])

export default __exports__